import { useState, useCallback } from 'react'

export function usePortraitState() {
  const [brokenPortraits, setBrokenPortraits] = useState<Set<string>>(new Set())

  const markPortraitBroken = useCallback((id: string) => {
    setBrokenPortraits((prev) => new Set(prev).add(id))
  }, [])

  return { brokenPortraits, markPortraitBroken }
}
